import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import FixedWidthContainer from 'components/consumer/FixedWidthContainer';
import PDPProtectionPlanSelector from 'components/consumer/PDP/PDPProtectionPlanSelector';
import ReRenderOnMount from 'components/consumer/ReRenderOnMount';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import useProductEFGInternalStatus from 'data-hooks/useProductEFGInternalStatus';
import PDPKeySellingPoints from '../PDPKeySellingPoints';
import PDPNameSection from '../PDPNameSection';
import PDPShopTabsBar from '../PDPShopTabsBar';
import PDPOnDisplayInShowroom from '../PDPOnDisplayInShowroom';
import PDPAddToBagSection from '../PDPAddToBagSection';
import PDPUpSellProduct from '../PDPUpSellProduct';
import PDPBreadCrumbs from '../PDPBreadCrumbs';
import PDPAlertBar from '../PDPAlertBar';
import PDPAlertsSection from '../PDPAlertsSection';
import PDPDiscontinuedMessage from '../PDPDiscontinuedMessage';
import PDPChooseYourOptions from '../PDPChooseYourOptions';
import PDPGalleryLabels from '../PDPGalleryLabels';
import PDPInfoAccordion from '../PDPInfoAccordion';
import PDPMobileConfigurationPhotoGallery from '../PDPMobileConfigurationPhotoGallery';
import PDPMobileGalleryRevamp from '../PDPMobileGalleryRevamp';
import PDPMobileStudioPhotoGallery from '../PDPMobileStudioPhotoGallery';
import PDPSectionDivider from '../PDPSectionDivider';
import PDPMobileStickySummaryBar from '../PDPStickySummaryBar/PDPMobileStickySummaryBar';
import PDPCuralateGallery from '../PDPFooter/PDPCuralateGallery';
import { PDPRecentlyViewed } from '../PDPFooter';
import useIsGalleryRevampVariant from '../useIsGalleryRevampVariant';
import usePDPOptions from '../state/context/usePDPOptions';
const PDPCollectionSlider = loadable(() => import('../PDPCollectionSlider'));
const PDPMobileRevamp = t0 => {
  const $ = _c(64);
  const {
    discontinuedCategoryMsg: t1,
    isOutOfStock: t2,
    showDiscontinuedNotification: t3,
    showOutOfStockNotification: t4,
    slug,
    productHeroImage: t5,
    productCylindoHeroImage: t6
  } = t0;
  const discontinuedCategoryMsg = t1 === undefined ? null : t1;
  const isOutOfStock = t2 === undefined ? false : t2;
  const showDiscontinuedNotification = t3 === undefined ? false : t3;
  let t7;
  if ($[0] !== t4) {
    t7 = t4 === undefined ? {} : t4;
    $[0] = t4;
    $[1] = t7;
  } else {
    t7 = $[1];
  }
  const showOutOfStockNotification = t7;
  const productHeroImage = t5 === undefined ? null : t5;
  const productCylindoHeroImage = t6 === undefined ? null : t6;
  const isGalleryRevampVariant = useIsGalleryRevampVariant();
  const {
    isEFGInternal: t8
  } = useProductEFGInternalStatus();
  const isEFGInternal = t8 === undefined ? false : t8;
  const {
    data: optionData
  } = usePDPOptions();
  const [displayPressComp, setDisplayPressComp] = useState(false);
  const [nameSection, setNameSection] = useState(null);
  let t9;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="mb-4"><PDPBreadCrumbs /></div>;
    $[2] = t9;
  } else {
    t9 = $[2];
  }
  let t10;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <FixedWidthContainer><PDPGalleryLabels /></FixedWidthContainer>;
    $[3] = t10;
  } else {
    t10 = $[3];
  }
  let t11;
  if ($[4] !== nameSection) {
    t11 = <PDPMobileStickySummaryBar nameSection={nameSection} />;
    $[4] = nameSection;
    $[5] = t11;
  } else {
    t11 = $[5];
  }
  let t12;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div ref={setNameSection}><PDPNameSection disableStickyPriceRow={true} hideProductLabel={true} hideRatings={true} /></div>;
    $[6] = t12;
  } else {
    t12 = $[6];
  }
  let t13;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <FixedWidthContainer><PDPOnDisplayInShowroom /><hr className="border-0 border-t border-gray-light7 my-6" /></FixedWidthContainer>;
    $[7] = t13;
  } else {
    t13 = $[7];
  }
  let t14;
  if ($[8] !== isGalleryRevampVariant || $[9] !== productCylindoHeroImage || $[10] !== productHeroImage || $[11] !== slug) {
    t14 = <div>{isGalleryRevampVariant ? <PDPMobileGalleryRevamp slug={slug} productHeroImage={productHeroImage} productCylindoHeroImage={productCylindoHeroImage} hideProductLabel={true} hideDecideLaterOverlay={true} /> : <PDPMobileStudioPhotoGallery slug={slug} productHeroImage={productHeroImage} productCylindoHeroImage={productCylindoHeroImage} />}</div>;
    $[8] = isGalleryRevampVariant;
    $[9] = productCylindoHeroImage;
    $[10] = productHeroImage;
    $[11] = slug;
    $[12] = t14;
  } else {
    t14 = $[12];
  }
  let t15;
  if ($[13] !== isOutOfStock || $[14] !== showDiscontinuedNotification) {
    t15 = !isOutOfStock && !showDiscontinuedNotification ? <FixedWidthContainer><PDPShopTabsBar hideDecideLaterTab={true} isLayoutRevamp={true} /></FixedWidthContainer> : <div className="PDPMobileRevamp__PDPShopTabsBar-filler" />;
    $[13] = isOutOfStock;
    $[14] = showDiscontinuedNotification;
    $[15] = t15;
  } else {
    t15 = $[15];
  }
  let t16;
  if ($[16] !== isEFGInternal || $[17] !== isGalleryRevampVariant || $[18] !== optionData?.hasSingleOptionValue || $[19] !== slug) {
    t16 = <ReRenderOnMount>{!isGalleryRevampVariant && (!isEFGInternal || !optionData?.hasSingleOptionValue) ? <div className="PDPMobile__PDPMobileConfigurationPhotoGallery-wrapper"><PDPMobileConfigurationPhotoGallery slug={slug} marxentPostHogFlag="test" hideDecideLaterOverlay={true} /></div> : <div className="PDPMobile__PDPMobileConfigurationPhotoGallery-wrapper-filler" />}</ReRenderOnMount>;
    $[16] = isEFGInternal;
    $[17] = isGalleryRevampVariant;
    $[18] = optionData?.hasSingleOptionValue;
    $[19] = slug;
    $[20] = t16;
  } else {
    t16 = $[20];
  }
  let t17;
  if ($[21] !== discontinuedCategoryMsg || $[22] !== showDiscontinuedNotification) {
    t17 = showDiscontinuedNotification ? <PDPAlertBar type="error"><PDPDiscontinuedMessage discontinuedCategoryMsg={discontinuedCategoryMsg} /></PDPAlertBar> : <div className="PDPMobile__PDPAlertBar-filler" />;
    $[21] = discontinuedCategoryMsg;
    $[22] = showDiscontinuedNotification;
    $[23] = t17;
  } else {
    t17 = $[23];
  }
  let t18;
  if ($[24] !== isOutOfStock || $[25] !== showDiscontinuedNotification) {
    t18 = !isOutOfStock && !showDiscontinuedNotification ? <div className="PDPMobile__PDPChooseYourOptions-wrapper"><PDPChooseYourOptions isLayoutRevamp={true} /><PDPProtectionPlanSelector isLayoutRevamp={true} /></div> : <div className="PDPMobile__PDPChooseYourOptions-wrapper-filler" />;
    $[24] = isOutOfStock;
    $[25] = showDiscontinuedNotification;
    $[26] = t18;
  } else {
    t18 = $[26];
  }
  let t19;
  if ($[27] !== isOutOfStock || $[28] !== showDiscontinuedNotification || $[29] !== showOutOfStockNotification) {
    t19 = isOutOfStock && !showDiscontinuedNotification ? <PDPAlertsSection showOutOfStockNotification={showOutOfStockNotification} /> : <div className="PDPMobile__PDPAlertSection-filler" />;
    $[27] = isOutOfStock;
    $[28] = showDiscontinuedNotification;
    $[29] = showOutOfStockNotification;
    $[30] = t19;
  } else {
    t19 = $[30];
  }
  let t20;
  if ($[31] !== showDiscontinuedNotification) {
    t20 = !showDiscontinuedNotification && <hr className="border-0 border-t border-gray-light7 my-6" />;
    $[31] = showDiscontinuedNotification;
    $[32] = t20;
  } else {
    t20 = $[32];
  }
  let t21;
  if ($[33] !== isOutOfStock) {
    t21 = <PDPAddToBagSection isOutOfStock={isOutOfStock} keepAddToBagLabel={true} />;
    $[33] = isOutOfStock;
    $[34] = t21;
  } else {
    t21 = $[34];
  }
  let t22;
  if ($[35] !== isOutOfStock || $[36] !== showDiscontinuedNotification) {
    t22 = !isOutOfStock && !showDiscontinuedNotification ? <PDPUpSellProduct /> : <div className="PDPMobileRevamp__add-ons-filler" />;
    $[35] = isOutOfStock;
    $[36] = showDiscontinuedNotification;
    $[37] = t22;
  } else {
    t22 = $[37];
  }
  let t23;
  if ($[38] !== t17 || $[39] !== t18 || $[40] !== t19 || $[41] !== t20 || $[42] !== t21 || $[43] !== t22) {
    t23 = <div>{t17}{t18}{t19}{t20}{t21}{t22}</div>;
    $[38] = t17;
    $[39] = t18;
    $[40] = t19;
    $[41] = t20;
    $[42] = t21;
    $[43] = t22;
    $[44] = t23;
  } else {
    t23 = $[44];
  }
  let t24;
  let t25;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <PDPKeySellingPoints mobileCarousel={true} />;
    t25 = <PDPInfoAccordion />;
    $[45] = t24;
    $[46] = t25;
  } else {
    t24 = $[45];
    t25 = $[46];
  }
  let t26;
  if ($[47] !== t23) {
    t26 = <FixedWidthContainer>{t23}{t24}{t25}</FixedWidthContainer>;
    $[47] = t23;
    $[48] = t26;
  } else {
    t26 = $[48];
  }
  let t27;
  if ($[49] !== displayPressComp) {
    t27 = !displayPressComp ? <><PDPSectionDivider className="my-8" /><SuspenseWithLoader><PDPCollectionSlider setDisplayPressComp={setDisplayPressComp} isLayoutRevamp={true} /></SuspenseWithLoader></> : <div className="PDPMobile__PDPPress-filler" />;
    $[49] = displayPressComp;
    $[50] = t27;
  } else {
    t27 = $[50];
  }
  let t28;
  let t29;
  let t30;
  if ($[51] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <PDPSectionDivider className="my-8" />;
    t29 = <PDPCuralateGallery isLayoutRevamp={true} />;
    t30 = <PDPSectionDivider className="my-8" />;
    $[51] = t28;
    $[52] = t29;
    $[53] = t30;
  } else {
    t28 = $[51];
    t29 = $[52];
    t30 = $[53];
  }
  let t31;
  if ($[54] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = <SuspenseWithLoader><PDPRecentlyViewed isLayoutRevamp={true} /></SuspenseWithLoader>;
    $[54] = t31;
  } else {
    t31 = $[54];
  }
  let t32;
  if ($[55] !== t27) {
    t32 = <FixedWidthContainer className="max-md:!px-4">{t27}{t28}{t29}{t30}{t31}</FixedWidthContainer>;
    $[55] = t27;
    $[56] = t32;
  } else {
    t32 = $[56];
  }
  let t33;
  if ($[57] !== t11 || $[58] !== t14 || $[59] !== t15 || $[60] !== t16 || $[61] !== t26 || $[62] !== t32) {
    t33 = <div className="PDPMobileRevamp lg:hidden" data-xc="PDPMobileRevamp">{t9}{t10}{t11}{t12}{t13}{t14}{t15}{t16}{t26}{t32}</div>;
    $[57] = t11;
    $[58] = t14;
    $[59] = t15;
    $[60] = t16;
    $[61] = t26;
    $[62] = t32;
    $[63] = t33;
  } else {
    t33 = $[63];
  }
  return t33;
};
PDPMobileRevamp.propTypes = {
  discontinuedCategoryMsg: PropTypes.shape({
    category: PropTypes.string,
    link: PropTypes.string
  }),
  isOutOfStock: PropTypes.bool,
  showDiscontinuedNotification: PropTypes.bool,
  showOutOfStockNotification: PropTypes.shape({
    productId: PropTypes.number,
    show: PropTypes.bool
  }),
  slug: PropTypes.string,
  productHeroImage: PropTypes.shape({
    src: PropTypes.string.isRequired,
    width: PropTypes.number,
    height: PropTypes.number,
    alt: PropTypes.string
  }),
  productCylindoHeroImage: PropTypes.shape({
    src: PropTypes.string.isRequired,
    width: PropTypes.number,
    height: PropTypes.number,
    alt: PropTypes.string
  })
};
export default PDPMobileRevamp;